import React, { useState } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CartInSlider from '../../../../components/cards/CartInSlider';
import { notifyError } from '../../../../components/general/Notification';

const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 3.3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1254,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 587,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
};
function SliderCart({ cartArr, setCartArr }) {

    const [cartData, setCartData] = useState([
        {
            id: 1,
            name: "Camera 1",
            brand: "XXX",
            model: "yyy",
            category: "Category 1",
            sub_category: "Sub Category 1",
            warehouse: "Warehouse 1",
            Type: "Type 1",
            description: "description descrip desc description descrip desc",
            url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
            qty: 15,
            supplier: "Fadi Ayyas",
            newQty: 0
        },
        {
            id: 2,
            name: "Camera 2",
            brand: "XXX",
            model: "yyy",
            category: "Category 2",
            sub_category: "Sub Category 2",
            warehouse: "Warehouse 2",
            Type: "Type 2",
            description: "description descrip desc description descrip desc",
            url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
            qty: 15,
            supplier: "Fadi Ayyas",
            newQty: 0
        },
        {
            id: 3,
            name: "Camera 3",
            brand: "XXX",
            model: "yyy",
            category: "Category 3",
            sub_category: "Sub Category 3",
            warehouse: "Warehouse 3",
            Type: "Type 3",
            description: "description descrip desc description descrip desc",
            url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
            qty: "15",
            supplier: "Fadi Ayyas",
            newQty: 0
        },
        {
            id: 4,
            name: "Camera 4",
            brand: "XXX",
            model: "yyy",
            category: "Category 4",
            sub_category: "Sub Category 4",
            warehouse: "Warehouse 4",
            Type: "Type 4",
            description: "description descrip desc description descrip desc",
            url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
            qty: 15,
            supplier: "Fadi Ayyas",
            newQty: 0
        }
    ]);
    const handleIncrement = (id) => {
        const updatedCartData = cartData.map(item => {
            if (item.id === id && item.newQty < item.qty) {
                return { ...item, newQty: item.newQty + 1 };
            }
            return item;
        });
        setCartData(updatedCartData);
    };

    const handleDecrement = (id) => {
        const updatedCartData = cartData.map(item => {
            if (item.id === id && item.newQty > 0) {
                return { ...item, newQty: item.newQty - 1 };
            }
            return item;
        });
        setCartData(updatedCartData);
    };
    const handleAddToCart = (item) => {
        if (item.newQty > 0) {
            const isItemInCart = cartArr.find(cartItem => cartItem.id === item.id);
            if (!isItemInCart) {
                setCartArr(prevCartArr => [...prevCartArr, item]);
            }else{
                notifyError('This Item is existed')
            }
        } else {
            notifyError('Quantity must be greater than 0')
        }
    };

    return (
        <Slider {...settings} className='silder11' >
            {
                cartData.map((datum) => (
                    <div className='inside_silder' key={datum.id}>
                        <CartInSlider datum={datum} handleIncrement={handleIncrement} handleDecrement={handleDecrement} handleAddToCart={handleAddToCart} />
                    </div>
                ))
            }
        </Slider>
    );
}

export default SliderCart;